// extracted by mini-css-extract-plugin
export default {"board_wrapper":"AbandonBoard_board_wrapper__nW3bP","board_img":"AbandonBoard_board_img__CPgIc"};